import { createTranslations } from '@npco/common-utils-translations'

export const savingsAccountBannerTranslations = createTranslations({
  title: 'Earn up to {interest} with a Zeller Savings Account.',
  emphasis: '{effectiveInterestRate}% p.a. {asterisk} ',
  asterisk: '*',
  list1: 'Activate in seconds',
  list2: 'Access your funds instantly',
  list3: 'Interest calculated daily',
  savingsAccount: 'Zeller Savings Account',
  activate: 'Activate',
  anchor: 'Terms apply',
  termsAndConditions: '* {termsAndConditionsAnchor}.',
  termsAndConditionsBonus:
    '* Earn a competitive {base}% p.a. standard variable rate, plus an additional {bonus}% p.a. for {bonusLength} days from Savings Account activation. {base}% p.a. standard variable rate applies thereafter. {termsAndConditionsAnchor}.',
  titleMarch: 'Earn {interest} with a Zeller Savings Account.',
  termsAndConditionsMarch:
    '* Earn an amazing {interest}% p.a. standard variable rate on any funds saved in an active Zeller Savings Account between 1 and 31 March 2024 (AET). {termsAndConditionsAnchor}.',
})
